import type { WhatsAppInboxChat, WhatsAppInboxMessage } from '@zrsystem/contracts';

import { resolveWhatsAppInboxChatKind } from '@/features/notification/lib/whatsapp-inbox-chat-kind.js';
import { resolveWhatsAppInboxMediaKind } from '@/features/notification/lib/whatsapp-inbox-media-kind.js';

export function whatsAppInboxChatDisplayName(chat: Pick<WhatsAppInboxChat, 'id' | 'name'>): string {
  const trimmed = chat.name?.trim();
  if (trimmed !== undefined && trimmed.length > 0) {
    return trimmed;
  }
  return resolveWhatsAppInboxChatKind(chat.id) === 'group' ? 'Grupo' : 'Contato';
}

function singleLinePreview(text: string | null): string {
  if (text === null) {
    return '';
  }
  return text.replace(/\s+/g, ' ').trim();
}

export function whatsAppInboxMessagePreviewLabel(
  message:
    | Pick<WhatsAppInboxMessage, 'body' | 'hasMedia' | 'media'>
    | Pick<NonNullable<WhatsAppInboxChat['lastMessage']>, 'body'>
    | null,
): string {
  if (message === null) {
    return 'Nenhuma mensagem ainda';
  }

  const mediaKind = 'hasMedia' in message ? resolveWhatsAppInboxMediaKind(message) : null;
  if (mediaKind === 'image') {
    const caption = singleLinePreview(message.body);
    return caption.length > 0 ? caption : 'Foto';
  }
  if (mediaKind === 'audio') {
    return 'Áudio';
  }
  if (mediaKind === 'video') {
    const caption = singleLinePreview(message.body);
    return caption.length > 0 ? caption : 'Vídeo';
  }
  if (mediaKind === 'file') {
    const filename =
      'media' in message && message.media !== null ? singleLinePreview(message.media.filename) : '';
    return filename.length > 0 ? filename : 'Arquivo';
  }

  const text = singleLinePreview(message.body);
  return text.length > 0 ? text : 'Mensagem';
}

export function whatsAppInboxParticipantLabel(
  message: Pick<WhatsAppInboxMessage, 'participant' | 'author'>,
): string | null {
  const participant = message.participant?.trim();
  if (participant !== undefined && participant.length > 0) {
    return participant;
  }
  const author = message.author?.trim();
  if (author !== undefined && author.length > 0) {
    return author;
  }
  return null;
}
